
/**
 *	globals:
 *
 *	Allgemeine states, die von verschiedenen components / views
 *	benötigt werden.
 *
 * 	Beispiel zum Ändern eines globalen Wertes von einer Komponente aus:
 * 	this.$store.commit('navigation/SET_DATA', obj);
 *
 * 	Zugriff auf Wert aus Komponente:
 * 	this.$store.state.navigation
 *
 * 	Alternativ mapState() verwenden:
 * 	import { mapState } from 'vuex';
 * 	computed: {
 * 		...mapState('navigation', ['current']),
 * 	}
 * 	Zugriff: this.app.innerWidth
 *
 */

import { EventBus } from '@/common/eventbus.js'

export const state = {
	current: false,
	history: [],
	data: {},
}


export const mutations = {

	/**
	 * 	Navi-Data setzen
	 * 
	 */
	SET_DATA(state, obj) {
		state.data = obj;
	},

	/**
	 * 	Aktuell ausgewählten Menüpunkt setzen
	 * 
	 */
	SET_CURRENT(state, obj) {
		state.current = obj;
	}
	
}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
